var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2 mx-auto loader-spinner",class:{ 'd-flex justify-content-center' : _vm.loading },attrs:{"id":"loader"}},[_c('Stretch',{attrs:{"background":"#ec0000"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }